export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Sneakers, running shoes, casual footwear",
  },
  {
    name: "Hoodies/Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    description: "Pullover hoodies, zip-ups, crewnecks",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    description: "Graphic tees, plain shirts, long sleeves",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    description: "Bombers, denim jackets, windbreakers",
  },
  {
    name: "Pants/Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    description: "Cargo pants, denim, athletic shorts",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    description: "Caps, beanies, bucket hats",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    description: "Matching tracksuits, coordinated outfits",
  },
  {
    name: "Underwear/Underpants",
    slug: "underwear-underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    description: "Boxers, briefs, undershirts",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    description: "Sports jerseys, football kits, basketball",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    description: "Wallets, jewelry, sunglasses, watches",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    description: "Backpacks, crossbody bags, totes",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    description: "Leather belts, designer belts, casual",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    description: "Designer fragrances, unisex scents",
  },
  {
    name: "OtherStuff",
    slug: "otherstuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    description: "Miscellaneous finds, unique items",
  },
];